import React, { useState } from 'react';
import {
  ContainerAlert,
  ContainerInfo,
  ContainerTexts,
  ContentIcon,
  OverflowHidden,
  OverlayHidden,
  Text,
  Title,
} from './styles';
import { HighlightIcon, IconClose } from 'takeat-design-system-ui-kit';

export const AlertMessageComponent = ({
  icon,
  color,
  title,
  text,
  colorBorder,
}) => {
  const [open, setOpen] = useState(true);

  return (
    open && (
      <OverlayHidden>
        <ContainerAlert colorBorder={colorBorder}>
          <ContainerInfo>
            <ContentIcon>
              {<HighlightIcon icon={icon} color={color} />}
            </ContentIcon>
            <ContainerTexts>
              <Title>{title}</Title>
              <Text>{text}</Text>
            </ContainerTexts>
          </ContainerInfo>
          <div>
            <IconClose
              fontSize={20}
              style={{ cursor: 'pointer' }}
              onClick={() => setOpen(false)}
            />
          </div>
        </ContainerAlert>
      </OverlayHidden>
    )
  );
};
